import { Button, Card, FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { StyledTextField } from "../../Components/TextField/TextField";
import { deleteClient } from "../../Services/API/BaseClientManagement";
import LoadingBar from "../LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
    justifyContent: "space-between",
    width: "30%",
    height: "25%",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      paddingLeft: "10px",
    },
    fontSize: "24px",
    paddingTop: "5%",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  input: {
    height: "25%",
    width: "90%",
  },
  buttonSection: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "25%",
    width: "100%",
    marginBottom: "5%",
  },
  button: {
    [theme.breakpoints.down("sm")]: {
      minWidth: "unset",
      minHeight: "unset",
      width: "30%",
    },
    minWidth: "200px",
    minHeight: "50px",
  },
  textField: {
    "& .Mui-error": {
      color: "rgba(255,0,0,.7)",
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(255,0,0,.7)",
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "rgba(255,0,0,.7) !important",
    },
  },
}));

export default function DeleteBaseClientModal({
  clientId,
  clientName,
  closeModal,
  setDeleteProcessing,
  deleteProcessing,
  successfulDelete,
  setSuccessfulDelete,
}) {
  const classes = useStyles();
  const history = useHistory();

  const [inputClientName, setInputclientName] = useState("");
  const [showInputError, setShowInputError] = useState(false);
  const [showError, setShowError] = useState(false);

  const confirm = () => {
    if (checkClientName()) {
      setShowInputError(false);
      setDeleteProcessing(true);
      deleteClient(clientId).then((res) => {
        if (res) {
          setDeleteProcessing(false);
          setSuccessfulDelete(true);
          setShowError(false);
        } else {
          setDeleteProcessing(false);
          setShowError(true);
        }
      });
    } else {
      setShowInputError(true);
    }
  };

  const returnToClientList = () => {
    closeModal();
    history.push("/baseclientmanagement");
  };

  const checkClientName = () => {
    if (clientName !== inputClientName) {
      return false;
    }
    return true;
  };

  return (
    <Card className={classes.root}>
      <LoadingBar loading={deleteProcessing} />
      {!successfulDelete && !showError ? (
        <>
          <span className={classes.title}>
            To confirm delete, please type client name below:
          </span>
          <div className={classes.input}>
            <Grid xs={12} sm={12} item container>
              <StyledTextField
                InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                className={classes.textField}
                variant="standard"
                fullWidth
                required
                error={showInputError}
                disabled={deleteProcessing}
                onChange={(e) => setInputclientName(e.target.value)}
                data-test="delete-base-client-name-input"
              />
              {showInputError ? (
                <FormHelperText style={{ color: "rgba(255,0,0,.7)" }}>
                  Client name incorrect
                </FormHelperText>
              ) : null}
            </Grid>
          </div>
          <div className={classes.buttonSection}>
            <Button
              className={classes.button}
              style={{ color: "#82B288" }}
              type="submit"
              variant="outlined"
              disabled={deleteProcessing}
              onClick={() => closeModal()}
              data-test="delete-base-client-cancel"
            >
              Cancel
            </Button>
            <Button
              className={classes.button}
              style={{ backgroundColor: "#E45E42" }}
              type=""
              variant="contained"
              color="primary"
              disabled={deleteProcessing}
              onClick={() => confirm()}
              data-test="delete-base-client-button"
            >
              DELETE
            </Button>
          </div>
        </>
      ) : (
        <>
          {!showError ? (
            <>
              <span className={classes.title}>Successfully Deleted Client</span>
              <div className={classes.buttonSection}>
                <Button
                  className={classes.button}
                  style={{ backgroundColor: "#82B288" }}
                  type=""
                  variant="contained"
                  color="primary"
                  onClick={() => returnToClientList()}
                  data-test="delete-base-client-return-button"
                >
                  Return To Client List
                </Button>
              </div>
            </>
          ) : (
            <>
              <span className={classes.title}>Error Deleting Client</span>
              <div className={classes.buttonSection}>
                <Button
                  className={classes.button}
                  style={{ backgroundColor: "#82B288" }}
                  type=""
                  variant="contained"
                  color="primary"
                  onClick={() => closeModal()}
                  data-test="delete-base-client-return-button-error"
                >
                  Return To Edit Client
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </Card>
  );
}
